// Generated by CoffeeScript 1.8.0
var bind;

bind = function() {
  return function(string, payload) {
    if (payload == null) {
      return string;
    }
    return string.replace(/{([^{}]+)}/g, function(original, key) {
      if (payload[key] == null) {
        return original;
      }
      return payload[key];
    });
  };
};

if (typeof define !== "undefined" && define !== null) {
  define([], bind);
} else if (typeof module !== "undefined" && module !== null) {
  module.exports = bind();
} else {
  window.template = bind();
}